import React from 'react';

import { flagStyles } from '../settings';

const SvgTL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5232px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTL;
